import {currentFormatter} from '../../reports';

export const getColumns = (isAgentDetailsShown: boolean, isGroupShown: boolean) => [
  {
    id: 'dba',
    numeric: false,
    sortable: false,
    label: 'DBA',
  },
  {
    id: 'mid',
    numeric: false,
    sortable: false,
    label: 'Merchant ID',
  },
  ...(isGroupShown
    ? [
        {
          id: 'groupName',
          numeric: false,
          sortable: false,
          label: 'Group',
        },
      ]
    : []),
  ...(isAgentDetailsShown
    ? [
        {
          id: 'agentName',
          numeric: false,
          sortable: false,
          label: 'Agent Name',
        },
      ]
    : []),
  {
    id: 'dejavooEquipmentCount',
    numeric: true,
    sortable: false,
    label: 'Dejavoo Count',
    align: 'center',
  },
  {
    id: 'dejavooEquipmentAgentExpense',
    numeric: false,
    sortable: false,
    label: 'Dejavoo Expense',
    align: 'center',
    selector: (row: any) => currentFormatter.format(row.dejavooEquipmentAgentExpense || 0),
  },
  {
    id: 'dejavooAdditionalEquipmentAgentExpense',
    numeric: false,
    sortable: false,
    label: 'Dejavoo Additional Terminal Expense',
    align: 'center',
    selector: (row: any) =>
      currentFormatter.format(row.dejavooAdditionalEquipmentAgentExpense || 0),
  },
  {
    id: 'valorEquipmentCount',
    numeric: false,
    sortable: false,
    label: 'Valor Count',
    align: 'center',
  },
  {
    id: 'valorEquipmentAgentExpense',
    numeric: false,
    sortable: false,
    label: 'Valor Expense',
    align: 'center',
    selector: (row: any) => currentFormatter.format(row.valorEquipmentAgentExpense || 0),
  },
  {
    id: 'valorAdditionalEquipmentAgentExpense',
    numeric: false,
    sortable: false,
    label: 'Valor Additional Terminal Expense',
    align: 'center',
    selector: (row: any) => currentFormatter.format(row.valorAdditionalEquipmentAgentExpense || 0),
  },
  {
    id: 'equipmentAgentExpense',
    numeric: false,
    sortable: false,
    label: 'Expense',
    align: 'center',
    selector: (row: any) => currentFormatter.format(row.equipmentAgentExpense || 0),
  },
];
